import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const Template1 = () => {
    const navigate = useNavigate();

    return (
        <div className="bg-gray-100 min-h-screen font-sans">
            <header className="bg-white shadow relative z-10">
                <div className="container mx-auto p-4 flex justify-between items-center">
                    <button
                        onClick={() => navigate('/TemplateThemes')}
                        className="flex items-center gap-2 px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition-colors"
                    >
                        <ArrowLeft size={18} /> Back to Templates
                    </button>
                    <h1 className="text-2xl font-bold text-gray-800">Designer Profile</h1>
                    <div className="w-24"></div> {/* Placeholder for alignment */}
                </div>
            </header>

            <main className="max-w-screen-2xl mx-auto p-4 sm:p-6 lg:p-12">
                <div className="lg:grid lg:grid-cols-12 lg:gap-5">

                    {/* Sidebar: Designer Details - Replicated from DesignerPage1 */}
                    <div className="lg:col-span-3 lg:sticky lg:top-12 self-start flex flex-col items-center lg:items-start text-center lg:text-left mb-8 lg:mb-0">
                        <img 
                            src="https://placehold.co/150x150/E0E0E0/333333?text=Profile" 
                            alt="Designer Profile" 
                            className="w-40 h-40 object-cover rounded-full border-4 border-white/50 shadow-lg" 
                        />
                        <h2 className="text-3xl font-bold mt-4">Designer Name</h2>
                        <p className="text-gray-500 mt-2">Designer's Location</p>
                        
                        <div className="mt-6 bg-white rounded-lg shadow-sm border border-gray-200 p-6 w-full max-w-sm">
                            <h3 className="text-xl font-semibold mb-3 text-gray-800" style={{ fontFamily: "'IM Fell English', serif" }}>
                                About the Designer
                            </h3>
                            <div className="text-gray-600 leading-relaxed whitespace-pre-wrap" style={{ fontFamily: "'IM Fell English', serif" }}>
                                As a visionary in fashion, I craft timeless pieces where tradition meets contemporary elegance. My designs are inspired by art, history, and the beauty of natural fabrics, creating a unique story with every garment.
                            </div>
                        </div>
                    </div>

                    {/* Main Content: Product Grid - Replicated from DesignerPage1 */}
                    <div className="lg:col-span-9">
                        <div className="flex justify-between items-baseline mb-6 border-b border-gray-200 pb-4">
                            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 capitalize" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
                                All Products
                            </h2>
                            <span className="text-sm text-gray-500">8 items shown</span>
                        </div>
                        
                        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
                            {[1, 2, 3, 4, 5, 6, 7, 8].map(id => (
                                <div key={id} className="bg-white p-4 rounded-lg shadow-sm">
                                    <img src={`https://placehold.co/400x500/F0F0F0/333333?text=Product+${id}`} alt={`Product ${id}`} className="w-full h-64 object-cover rounded-md mb-4" />
                                    <h3 className="font-semibold text-gray-800 text-lg">Product Title {id}</h3>
                                    <p className="text-gray-600 mt-1">$XX.XX</p>
                                    <button className="mt-3 w-full px-4 py-2 bg-gray-800 text-white rounded-md hover:bg-gray-700 transition-colors">Add to Cart</button>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </main>

            <footer className="bg-gray-800 text-white text-center p-6 mt-8">
                <p>&copy; 2025 Classic Store. All rights reserved.</p>
            </footer>
        </div>
    );
};

export default Template1;